import { render, staticRenderFns } from "./NotesSubList.vue?vue&type=template&id=35da2432&scoped=true"
import script from "./NotesSubList.vue?vue&type=script&lang=js"
export * from "./NotesSubList.vue?vue&type=script&lang=js"
import style0 from "./NotesSubList.vue?vue&type=style&index=0&id=35da2432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da2432",
  null
  
)

export default component.exports